// import React, { useEffect, useMemo, useState } from "react";
// import { Controller, useForm } from "react-hook-form";
// import "./style.scss";
// import { useDispatch, useSelector } from "react-redux";
// import { setMatrixAnswer } from "../../Redux/Slices/User/matrixAnswers";

// const MatrixQuestions = ({
//   question,
//   savedAnswers,
//   onNotesChange,
//   notes: parentNotes,
//   categoryIndex,
//   subCategoryIndex,
//   questionIndex, }) => {
//   const dispatch = useDispatch();
//   const newQuestion = question?.questions[0];
//   const getMatrixAnswers = useSelector((state) => state.matrixAnswers.matrix);
//   const { control, watch, setValue } = useForm({ defaultValues: {} });
//   const answers = watch("answers");
//   const [localNotes, setLocalNotes] = useState(parentNotes || "");

//   useEffect(() => {
//     if (!newQuestion?.subOptions) return;

//     newQuestion.subOptions.forEach(subOpt => {
//       const savedAnswer = getMatrixAnswers[newQuestion.question_id]?.find(
//         ans => ans.subOptionId === subOpt.sub_option_id
//       );
//       console.log(savedAnswer, "savedAnswer")
//       if (savedAnswer?.optionId === null || savedAnswer === undefined) {
//       setValue(`answers.${subOpt.sub_option_id}`, undefined);
//     } else {
//       setValue(`answers.${subOpt.sub_option_id}`, Number(savedAnswer.optionId));
//     }
//     });
//   }, [getMatrixAnswers, newQuestion, setValue,]);

//   const handleSelect = (questionId, subOptionId, optionId) => {
//     dispatch(setMatrixAnswer({ questionId, subOptionId, optionId }));
//   };
//   useEffect(() => {
//     setLocalNotes(parentNotes || "");
//   }, [parentNotes]);

//   const handleNotesChange = (e) => {
//     const value = e.target.value;
//     setLocalNotes(value);
//     onNotesChange(categoryIndex, subCategoryIndex, questionIndex, "notes", e);
//   };
//   return (
//     <div className="question-item mb-4" style={{ padding: 20 }}>
//       <h4>{newQuestion?.question_id}. {newQuestion?.question}</h4>
//       <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid #000" }}>
//         <thead style={{backgroundColor: "#1f2155", color:"#fff"}}>
//           <tr>
//             <th style={{ textAlign: "center", border: "1px solid #000", }}></th>
//             {newQuestion?.options?.map((opt, idx) => (
//               <th key={idx} style={{ textAlign: "center", border: "1px solid #000", padding: "8px" }}>{opt.title}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {newQuestion?.subOptions?.map((subOpt, subIdx) => (
//             <tr key={subIdx}>
//               <td style={{ border: "1px solid #000", padding: "8px" }}>{subOpt.title}</td>
//               {newQuestion?.options?.map((opt, optIdx) => (
//                 <td key={optIdx} style={{ textAlign: "center", border: "1px solid #000" }}>
//                   <Controller
//                     name={`answers.${subOpt.sub_option_id}`}
//                     control={control}
//                     render={({ field }) => (
//                       <input
//                         type="radio"
//                         value={opt?.option_id}
//                         style={{width : "20px", height : "20px"}}
//                         name={`answers.${subOpt?.sub_option_id}`}
//                         checked={field.value === Number(opt?.option_id)}
//                         onChange={(e) => {
//                           const value = Number(e.target.value);
//                           field.onChange(value);
//                           handleSelect(newQuestion?.question_id, subOpt?.sub_option_id, value);
//                         }}
//                       />
//                     )}
//                   />
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <div className="option-items mt-3">
//         <h4>Add your notes</h4>
//         <textarea
//           placeholder="Enter here..."
//           className="notes-input"
//           value={localNotes}
//           onChange={handleNotesChange}
//         />
//       </div>
//     </div>
//   );
// };

// export default MatrixQuestions;

import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import "./style.scss";

const MatrixQuestions = ({
  question,
  savedAnswers,
  matrixAnswers,
  setMatrixAnswers,
  categoryIndex,
  subCategoryIndex,
  questionIndex,
  onNotesChange
}) => {
  const newQuestion = question?.questions?.[0];
  const { control, watch, setValue } = useForm({ defaultValues: {} });
  const [localNotes, setLocalNotes] = useState("");

  // Prefill form based on parent matrixAnswers
  useEffect(() => {
    if (!newQuestion?.subOptions) return;

    newQuestion.subOptions.forEach(subOpt => {
      const savedAnswer = matrixAnswers[newQuestion.question_id]?.find(
        ans => ans.subOptionId === subOpt.sub_option_id
      );

      if (!savedAnswer || savedAnswer?.optionId === null) {
        setValue(`answers.${subOpt.sub_option_id}`, undefined);
      } else {
        setValue(`answers.${subOpt.sub_option_id}`, Number(savedAnswer.optionId));
      }
    });
  }, [matrixAnswers, newQuestion, setValue]);

  // Handle radio select
  const handleSelect = (questionId, subOptionId, optionId) => {
    setMatrixAnswers(prev => {
      const updated = { ...prev };
      const answers = updated[questionId] ? [...updated[questionId]] : [];
      const existingIndex = answers.findIndex(a => a.subOptionId === subOptionId);

      if (optionId === null) {
        // Remove if optionId is null
        if (existingIndex !== -1) answers.splice(existingIndex, 1);
      } else if (existingIndex !== -1) {
        answers[existingIndex] = { questionId, subOptionId, optionId };
      } else {
        answers.push({ questionId, subOptionId, optionId });
      }

      updated[questionId] = answers.length ? answers : undefined;
      return updated;
    });
  };

  // Notes logic (kept local to component)
  const handleNotesChange = (e) => {
    const value = e.target.value;
    setLocalNotes(value);
    onNotesChange(categoryIndex, subCategoryIndex, questionIndex, "notes", e);
  };

  return (
    <div className="question-item mb-4" style={{ padding: 20 }}>
      <h4>
        {newQuestion?.question_id}. {newQuestion?.question}
      </h4>

      <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid #000" }}>
        <thead style={{ backgroundColor: "#1f2155", color: "#fff" }}>
          <tr>
            <th style={{ textAlign: "center", border: "1px solid #000" }}></th>
            {newQuestion?.options?.map((opt, idx) => (
              <th key={idx} style={{ textAlign: "center", border: "1px solid #000", padding: "8px" }}>
                {opt.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {newQuestion?.subOptions?.map((subOpt, subIdx) => (
            <tr key={subIdx}>
              <td style={{ border: "1px solid #000", padding: "8px" }}>{subOpt.title}</td>
              {newQuestion?.options?.map((opt, optIdx) => (
                <td key={optIdx} style={{ textAlign: "center", border: "1px solid #000" }}>
                  <Controller
                    name={`answers.${subOpt.sub_option_id}`}
                    control={control}
                    render={({ field }) => (
                      <input
                        type="radio"
                        value={opt?.option_id}
                        style={{ width: "20px", height: "20px" }}
                        name={`answers.${subOpt?.sub_option_id}`}
                        checked={field.value === Number(opt?.option_id)}
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          field.onChange(value);
                          handleSelect(newQuestion?.question_id, subOpt?.sub_option_id, value);
                        }}
                      />
                    )}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <div className="option-items mt-3">
        <h4>Add your notes</h4>
        <textarea
          placeholder="Enter here..."
          className="notes-input"
          value={localNotes}
          onChange={handleNotesChange}
        />
      </div>
    </div>
  );
};

export default MatrixQuestions;

